import { create } from 'zustand';

type DisplayMediaState = {
    accessDenied: boolean | undefined;
    isCapturing: boolean;
    currentStream: MediaStream | undefined;
    hasAudio: boolean;
    _setCapturing: () => void;
    _setCaptured: (stream: MediaStream) => void;
    _setFailed: (accessDenied: boolean) => void;
    _clear: () => void;
};

export const useDisplayMediaStore = create<DisplayMediaState>((set) => ({
    accessDenied: undefined,
    isCapturing: false,
    currentStream: undefined,
    hasAudio: false,
    _setCapturing: () => set({ isCapturing: true }),
    _setCaptured: (stream: MediaStream) =>
        set({
            isCapturing: false,
            accessDenied: false,
            currentStream: stream,
            hasAudio: true,
        }),
    _setFailed: (accessDenied: boolean) =>
        set({
            isCapturing: false,
            accessDenied,
            currentStream: undefined,
            hasAudio: false,
        }),
    _clear: () =>
        set({
            currentStream: undefined,
            hasAudio: false,
            isCapturing: false,
        }),
}));
